import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
`

const panelIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.985);
  }
`

export const PopoverBackdrop = styled.div`
  position: fixed;
  z-index: 1000;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(12, 15, 22, 0.76);
  backdrop-filter: blur(5px);

  @media screen and (max-width: 640px) {
    align-items: flex-end;
    padding: 0;
  }

  @media (prefers-reduced-motion: no-preference) {
    animation: ${fadeIn} 160ms ease-out;
  }
`

export const PopoverPanel = styled.section`
  display: flex;
  width: min(100%, 680px);
  max-height: min(90dvh, 800px);
  flex-direction: column;
  overflow: hidden;
  border: 1px solid #596170;
  border-radius: 18px;
  outline: none;
  color: #fff;
  background: #353c4b;
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.48);

  @media screen and (max-width: 640px) {
    width: 100%;
    max-height: 94dvh;
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    border-radius: 20px 20px 0 0;
  }

  @media (prefers-reduced-motion: no-preference) {
    animation: ${panelIn} 180ms ease-out;
  }
`

export const PopoverHeader = styled.header`
  display: flex;
  flex: 0 0 auto;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 22px 24px 18px;
  border-bottom: 1px solid #596170;

  h2,
  p {
    margin: 0;
  }

  h2 {
    font-size: 22px;
    line-height: 1.2;
  }

  p {
    margin-top: 6px;
    color: #b7c1d3;
    font-size: 13px;
    line-height: 1.45;
  }

  @media screen and (max-width: 640px) {
    padding: 14px 18px 15px;

    h2 {
      font-size: 19px;
    }
  }
`

export const PopoverCloseButton = styled.button`
  display: grid;
  width: 38px;
  height: 38px;
  flex: 0 0 auto;
  place-items: center;
  border: 1px solid #697386;
  border-radius: 50%;
  color: #fff;
  background: #252b36;
  cursor: pointer;
  font-family: inherit;
  font-size: 24px;
  line-height: 1;

  &:hover,
  &:focus-visible {
    border-color: #ff8e00;
    outline: none;
    color: #ffb24d;
  }
`

export const PopoverBody = styled.div`
  min-height: 0;
  padding: 24px;
  overflow-y: auto;
  overscroll-behavior: contain;

  @media screen and (max-width: 640px) {
    padding: 18px;
    padding-bottom: max(22px, env(safe-area-inset-bottom));
  }
`

export const MobileHandle = styled.span`
  display: none;

  @media screen and (max-width: 640px) {
    display: block;
    width: 42px;
    height: 5px;
    flex: 0 0 auto;
    border-radius: 5px;
    margin: 9px auto 0;
    background: #697386;
  }
`
